import jQuery from "jquery";
import { EVENT } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { LocationProvider } from "../stores-js/location/locationprovider";
import { DirectionsResultsDisplayer } from "../stores-js/ui/directionsresultsdisplayer";
import { OriginDestinationInput } from "../stores-js/ui/origindestinationinput";
import { SearchView } from "../stores-js/ui/searchview";
import templates from "../templates";
import {
    addBrandIcon,
    addBrandIconForDetailView,
    cleanMapFromRoutes,
    concatenateStoreAddress,
    createLocalitiesTableView,
    createWoosmapDirectionsProvider,
    createWoosmapLocalitiesAutoComplete,
    directionsStepsIcon,
    formatDistanceValue,
    generateGoogleMapsDirectionUrl,
    generateWazeDirectionUrl,
    getPaddingForWindow,
    getTransitMode,
    initDatePicker,
    initIcons,
    onItinaryDateChange,
    resetTrafficElements,
    sanitizeField,
    updateTrafficElements,
} from "../utils/global";
import { hideGeolocationNotice, showGeolocationNotice } from "../utils/notice";
import { BlockManager, initDirectionsSwitchButton, setVisibility, toggleDirectionsDetails } from "../utils/ui";
const $ = jQuery;

total.maps.desktop = total.maps.desktop || {};

export default class DirectionsView extends woosmap.map.MVCObject {
    constructor(sidePanel) {
        super();

        this.sidePanel = sidePanel;
        this.mapView = sidePanel.mapView;

        this.imageBaseUrl = `${SETTINGS.serverUrl}css/images/icons/`;
        this.mapIconBaseUrl = `${SETTINGS.serverUrl}css/images/map-icons/`;

        this.imageTravelMode = {
            WALKING: `${this.imageBaseUrl}walk.png`,
            BICYCLING: `${this.imageBaseUrl}bike.png`,
            DRIVING: `${this.imageBaseUrl}car.png`,
            TRANSIT: `${this.imageBaseUrl}bus.png`,
        };

        this.reverseOriginDestination = false;

        this.selector = "#storemap-directionbar-container";
        this.mainElement = $(this.selector);
        this.mainElement.html(templates.desktop.directions.render(total.maps.L10n.ui));

        this.location = null;
        this.userLocation = {};
        this.selectedStore = null;

        // Block itinerary display when user click on an other store
        this.blockSelectedStoreEvent = true;

        // SearchView
        this.woosmapSearchView = new SearchView(
            templates.desktop.originSearch.render(total.maps.L10n.ui),
            "<span>{{name}}</span>",
        );
        this.mainElement.find(".wm-directions--origin").html(this.woosmapSearchView.getContainer());

        // PlaceSearch and TableView for prediction results
        let googlePlaceAutocompleteOptions;

        this.directionsMarkers = [];
        this.itineraryFiltersSet = false;
        /*
    if (this.mapView.countryCode) {
      googlePlaceAutocompleteOptions = {
        types: ['geocode'],
        componentRestrictions: { country: this.mapView.countryCode },
      };
    } else {
      googlePlaceAutocompleteOptions = { types: ['geocode'] };
    }
    */

        // this.woosmapPlacesSearchSource = new woosmap.location.PlacesSearchSource(googlePlaceAutocompleteOptions, 3);
        const woosmapLocalitiesAutoComplete = createWoosmapLocalitiesAutoComplete(
            this.mainElement,
            "suggestionContainerClass",
        );

        // this.woosmapSugestionTableView = new woosmap.ui.TableView({
        //   cell_store: '<div></div>',
        //   cell_place: '<div class="storemap-suggestion-item">{{description}}</div>',
        // });

        const woosmapSugestionTableView = createLocalitiesTableView();

        woosmapSugestionTableView.bindTo("predictions", woosmapLocalitiesAutoComplete);

        this.bindTo("predictions", woosmapLocalitiesAutoComplete);
        woosmapLocalitiesAutoComplete.bindTo("autocomplete_query", this.woosmapSearchView, false);
        this.mainElement.find(".storemap-suggestionbar-container").append(woosmapSugestionTableView.getContainer());

        // Geolocalisation
        this.woosmapNavigatorGeolocation = new LocationProvider();

        // Direction

        this.woosmapOriginDestinationInput = new OriginDestinationInput(templates.desktop.directions.render(), {
            geolocText: total.maps.L10n.ui.common.myLocation,
        });

        // Add system metric
        const googleDirectionsRequestOptions = $.extend(SETTINGS.googleDirectionsRequestOptions, {
            unitSystem: google.maps.UnitSystem.METRIC,
        });

        this.woosmapDirectionsProvider = createWoosmapDirectionsProvider(
            SETTINGS.directionRendererOptions,
            googleDirectionsRequestOptions,
            () => {
                if (!$.isEmptyObject(this.userLocation)) {
                    this._clearMap();
                    this.mainElement.find("#storemap-directionlistbar-message-container").show();
                }
            },
        );

        this.woosmapDirectionsProvider.bindTo("originDestination", this.woosmapOriginDestinationInput);
        // this.woosmapDirectionsProvider.selectedTravelMode = "DRIVING";

        this.bindTo("originDestination", this.woosmapOriginDestinationInput);

        this.bindTo("location", this.woosmapNavigatorGeolocation);

        this.woosmapDirectionsResultsDisplayer = new DirectionsResultsDisplayer(this.sidePanel.mapView.map, "", () => {
            this.markers.clear();
            this.mapView.onLocationReset();
            // self.woosmapDirectionsResultsDisplayer.displayRouteOnMap(0);
            this.selectDirectionInList(0);
            const computedDirections = this.woosmapDirectionsResultsDisplayer.get("directionsRenderers")[0].directions;
            const leg = computedDirections.routes[0].legs[0];
            const currentTravelMode = this._getCurrentTravelMode() || "DRIVING";
            const startPosition = currentTravelMode === "TRANSIT" ? leg.start_location.location : leg.start_location;
            const endPosition = currentTravelMode === "TRANSIT" ? leg.end_location.location : leg.end_location;

            const originInputText = this.mainElement.find(".wm-directions--origin-input").val();
            const originFromGps = originInputText === total.maps.L10n.ui.common.myLocation;
            const originIconFile = originFromGps ? "position-target.svg" : "position.png";
            const originPosition = this.reverseOriginDestination ? endPosition : startPosition;
            this.markers.make(
                this.sidePanel.mapView.map,
                originPosition,
                {
                    url: `${this.mapIconBaseUrl}${originIconFile}`,
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                },
                "Start",
            );

            const bounds = computedDirections.routes[0].bounds;
            const southWest = currentTravelMode === "TRANSIT" ? bounds.getSouthWest() : bounds.southwest;
            const northEast = currentTravelMode === "TRANSIT" ? bounds.getNorthEast() : bounds.northeast;

            const computedBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(southWest),
                new google.maps.LatLng(northEast),
            );
            this.mapView.map.fitBounds(computedBounds, getPaddingForWindow());
            this.lastComputedBounds = computedBounds;

            // self.mapView.tiledView.fitBounds(computedDirections.routes[0].bounds, SETTINGS.paddingBounds);
        });

        this.woosmapDirectionsResultsDisplayer.bindTo("directionsSummaries", this.woosmapDirectionsProvider);
        this.woosmapDirectionsResultsDisplayer.bindTo("directionsRenderers", this.woosmapDirectionsProvider);
        this.woosmapDirectionsResultsDisplayer.bindTo("directionsLink", this.woosmapDirectionsProvider);

        woosmapSugestionTableView.bindTo("location", this);

        this.bindTo("directionsSummaries", this.woosmapDirectionsProvider);
        this.bindTo("directionsRenderers", this.woosmapDirectionsResultsDisplayer);
        this.bindTo("directionsLink", this.woosmapDirectionsProvider);

        this.set("location", {});

        this._wireEvents();
    }
    setupDirectionsDetails() {
        const button = document.querySelector('[data-id="directions-details-button"]');
        if (!button) {
            console.warn("Directions details button not found");
            return;
        }

        // Remove previous listeners to avoid duplicates
        button.removeEventListener("click", toggleDirectionsDetails);
        button.addEventListener("click", toggleDirectionsDetails);
        setVisibility("directions-details-button", "show");
        if (this.isDirectionResultsExpanded()) {
            setVisibility("directions-results", "show");
        } else {
            setVisibility("directions-results", "hide");
        }
        setVisibility("search-button", "hide");
    }
    show() {
        this.mainElement.show();
        const panel = document.querySelector(".wm-panel");
        const locator = document.querySelector(".storemap-store-locator");
        if (panel && locator) {
            panel.classList.add("wm-directions-mode");
            panel.classList.remove("wm-poi-list-mode");
            locator.classList.add("wm-directions-mode");
            locator.classList.remove("wm-poi-list-mode");
            panel.classList.remove("wm-route-mode");
            locator.classList.remove("wm-route-mode");
        }
        setVisibility("search-button", "show");
        setVisibility("wm-poi-list", "hide");
        const originInput = this.mainElement.find(".wm-directions--origin-input");
        // When arriving from the "search along route" flow (both route fields filled),
        // carry the route origin over to the directions origin and compute the route
        // straight away, instead of clearing the field.
        const routeOriginInput = document.querySelector('[data-id="route-origin-input"]');
        const routeDestinationInput = document.querySelector('[data-id="route-destination-input"]');
        const routeOriginText = routeOriginInput ? routeOriginInput.value.trim() : "";
        const routeDestinationText = routeDestinationInput ? routeDestinationInput.value.trim() : "";
        const routeOriginLocation = SERVICE_REGISTRY.itinaryService.getOrigin();
        const fromRouteFlow = routeOriginText !== "" && routeDestinationText !== "";
        // Focus the origin only when the user still has to type one; the route flow
        // pre-fills it and computes the route, so keeping the cursor there is pointless.
        if (!fromRouteFlow) {
            originInput.focus();
        }
        originInput.val(fromRouteFlow ? routeOriginText : "").trigger("change");
        const hasText = originInput.val().trim().length > 0;
        document.querySelector('[data-id="search-button"]').disabled = !hasText;

        // initRouteOptionButtons();
        initDirectionsSwitchButton();
        this._initDatePicker();
        // Reuse the resolved route origin so directions are computed automatically;
        // outside the route flow there is no origin yet and the user enters one manually.
        const searchLocation = fromRouteFlow && routeOriginLocation?.lat ? routeOriginLocation : null;
        setVisibility("directions-results", "hide");
        setVisibility("directions-details-button", "hide");

        //SERVICE_REGISTRY.locationService.getLocation();

        let originLocation = null;
        let destinationLocation = null;
        if (searchLocation?.lat) {
            this.woosmapOriginDestinationInput.set("selectedStore", null);
            originLocation = `${searchLocation.lng},${searchLocation.lat}`;
            destinationLocation = this.setStore();
            this.userLocation = searchLocation;
        } else {
            destinationLocation = this.setStore();
            this.userLocation = {};
        }
        // if (SERVICE_REGISTRY.locationService.getLocationText()) {
        //     this.mainElement
        //         .find(".wm-directions--origin-input")
        //         .val(SERVICE_REGISTRY.locationService.getLocationText())
        //         .trigger("change");
        //     this.mainElement.find(".storemap-inputbar-clear-button").show();
        // } else {
        //     this.mainElement.find(".wm-directions--origin-input").val("");
        //     const hasText = this.mainElement.find(".wm-directions--origin-input").val().trim().length > 0;
        //     document.querySelector('[data-id="search-button"]').disabled = !hasText;
        //     this.mainElement.find(".storemap-inputbar-clear-button").hide();
        // }

        if (originLocation && destinationLocation) {
            this.mainElement.find(".wm-directions--external-actions").addClass("wm-hidden");
            this.woosmapOriginDestinationInput.set("originDestination", {
                origin: originLocation,
                destination: destinationLocation,
            });
        } else {
            this.mainElement.find(".wm-directions--external-actions").removeClass("wm-hidden");
        }

        this.blockSelectedStoreEvent = false;
    }

    hide() {
        this.mainElement.hide();
    }
    fitLastBounds() {
        if (this.lastComputedBounds) {
            this.mapView.map.fitBounds(this.lastComputedBounds, getPaddingForWindow());
        }
    }

    clearOriginInput() {
        this.mainElement.find(".storemap-inputbar-input").val("");
        this.mainElement.find(".storemap-inputbar-clear-button").hide();
        this.mainElement.find(".storemap-suggestionbar-container").hide();

        this.woosmapOriginDestinationInput.set("location", {});
        this.set("location", {});

        // Pour éviter entre autre que l'autre du changement d'un moyen de transport, le calcul d'itinéraire soit réalisé
        this.woosmapDirectionsProvider.set("originDestination", {
            origin: "",
            destination: "",
        });

        this._clearMap();
    }

    _initDatePicker() {
        const hiddenInput = document.getElementById("directions-calendar-input");
        const triggerButton = document.querySelector('[data-id="calendar"]');
        initDatePicker(hiddenInput, triggerButton, false, this.woosmapOriginDestinationInput, (selectedDate) =>
            this.onDepartureDateSelectedCb(selectedDate),
        );
    }
    onDepartureDateSelectedCb(selectedDate) {
        this.itineraryFiltersSet = true;
        const selDateEl = document.getElementById("departureDt");
        const label = document.getElementById("lblDeparture");
        const button = document.querySelector('[data-id="departNow"]');
        updateTrafficElements(selectedDate, button, label, selDateEl);
    }
    _wireEvents() {
        const self = this;

        const setupAvoidFilters = () => {
            const directionOptions = {
                avoidHighways: false,
                avoidTolls: false,
                avoidFerries: false,
            };

            const resultsContainer = document.querySelector(".wm-directions--results");
            const avoidButtons = resultsContainer.querySelectorAll(".wm-route--avoid .wm-btn--pill");

            for (const button of avoidButtons) {
                button.addEventListener("click", () => {
                    self.itineraryFiltersSet = true;
                    button.classList.toggle("wm-active");
                    const option = button.getAttribute("data-id");
                    switch (option) {
                        case "highways":
                            directionOptions.avoidHighways = button.classList.contains("wm-active");
                            break;
                        case "tolls":
                            directionOptions.avoidTolls = button.classList.contains("wm-active");
                            break;
                        case "ferries":
                            directionOptions.avoidFerries = button.classList.contains("wm-active");
                            break;
                    }
                    SERVICE_REGISTRY.itinaryService.setRouteOptions(directionOptions);
                    const originDestination = self.woosmapOriginDestinationInput.get("originDestination");

                    if (originDestination) {
                        self.woosmapOriginDestinationInput.set("originDestination", {
                            origin: originDestination.origin,
                            destination: originDestination.destination,
                        });
                    }
                });
            }
            // Return a reset function to clear both state and UI
            return function resetAvoidOptions() {
                directionOptions.avoidHighways = false;
                directionOptions.avoidTolls = false;
                directionOptions.avoidFerries = false;

                for (const btn of avoidButtons) {
                    btn.classList.remove("wm-active");
                }
                SERVICE_REGISTRY.itinaryService.setRouteOptions(directionOptions);
            };
        };

        const resetAvoidButtons = setupAvoidFilters();

        const onCloseButtonClick = () => {
            hideGeolocationNotice();
            this._resetScheduleButtons();
            resetTrafficButtons();
            resetAvoidButtons();
            SERVICE_REGISTRY.locationService.resetLocation();
            SERVICE_REGISTRY.itinaryService.setOrigin(null);
            SERVICE_REGISTRY.itinaryService.setDestination(null);
            SERVICE_REGISTRY.itinaryService.setStartDatetime(null);
            if (document.querySelector(".wm-search--input")) {
                document.querySelector(".wm-search--input").value = "";
            }

            this._clearMap();
            // TO DO: TO BE OBSERVED.
            // this.woosmapOriginDestinationInput.set("originDestination", {
            //     origin: "",
            //     destination: "",
            // });
            const panel = document.querySelector(".wm-panel");
            const locator = document.querySelector(".storemap-store-locator");
            if (panel && locator) {
                panel.classList.remove("wm-directions-mode");
                panel.classList.add("wm-poi-list-mode");
                locator.classList.remove("wm-directions-mode");
                locator.classList.add("wm-poi-list-mode");
            }
            this.sidePanel.resetView();
            this.blockSelectedStoreEvent = true;
            this.itineraryFiltersSet = false;
        };

        const onContainerClick = function onContainerClick() {
            const directionList = self.mainElement.find(".wm-directions--results-list");
            const containerElement = $(this);
            const index = containerElement.index();
            const originalIndex = containerElement.data("original-index");

            if (!containerElement.hasClass("storemap-selected-item")) {
                containerElement.siblings().each(function () {
                    const container = $(this);
                    container.removeClass("storemap-selected-item");
                    container.find(".storemap-active-button").removeClass("storemap-active-button");
                    container.find(".storemap-directionlistitem-roadmap").hide();
                    container.find(".storemap-directionlistitem-sendtomail").hide();
                });
                containerElement.addClass("storemap-selected-item");
                self.get("directionsRenderers")[index].renderer.setRouteIndex(originalIndex);

                // self.woosmapDirectionsResultsDisplayer.cleanMapFromRoutes();
                // self.woosmapDirectionsResultsDisplayer.displayRouteOnMap(index);
                const currentTravelMode = self._getCurrentTravelMode();
                const computedDirections = self.get("directionsRenderers")[index].directions;
                const bounds = computedDirections.routes[0].bounds;
                const southWest = currentTravelMode === "TRANSIT" ? bounds.getSouthWest() : bounds.southwest;
                const northEast = currentTravelMode === "TRANSIT" ? bounds.getNorthEast() : bounds.northeast;

                const computedBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(southWest),
                    new google.maps.LatLng(northEast),
                );
                self.mapView.map.fitBounds(computedBounds, getPaddingForWindow());
                directionList.prepend(containerElement);
            }
        };
        const onMoreDetailsButtonClick = function (e) {
            const clicked = $(this);
            const moreText = `+ ${total.maps.L10n.ui.detail.see_details}`;
            const hideText = `- ${total.maps.L10n.ui.search.hide_details}`;
            const currentText = clicked.text().trim();
            if (currentText === moreText) {
                clicked.text(hideText);
            } else {
                clicked.text(moreText);
            }
            const buttonElement = $(this);
            const containerElement = buttonElement.closest(".wm-directions--result");
            const index = containerElement.index(".wm-directions--result");
            const roadMapElement = containerElement.find(".wm-results--details-info");
            const mailButtonElement = containerElement.find(".storemap-directionlistitem-mail-button");
            const mailElement = containerElement.find(".storemap-directionlistitem-sendtomail");

            const currentTravelMode = self._getCurrentTravelMode();
            const directionInformations =
                currentTravelMode === "TRANSIT"
                    ? self.get("directionsRenderers")[index].directions.routes[0]
                    : self.get("directionsRenderers")[index].directions.routes[0].legs[0];

            mailButtonElement.removeClass("storemap-active-button");
            mailElement.hide();

            // roadMapElement.html(templates.desktop.directionRoadmapRow.render());

            const distance =
                currentTravelMode === "TRANSIT"
                    ? self.get("directionsRenderers")[index].summary.distance
                    : directionInformations.distance.text;
            const duration =
                currentTravelMode === "TRANSIT"
                    ? self.get("directionsRenderers")[index].summary.durationLong
                    : directionInformations.duration.text;
            roadMapElement.find(".storemap-roadmap-distance").text(distance);
            roadMapElement.find(".storemap-roadmap-duration").text(duration);

            const { steps } = directionInformations;
            const store = SERVICE_REGISTRY.storeService.getSelectedStore();

            let imageMarker = SETTINGS.defaultBrandIcon;

            if (store?.properties?.user_properties.brand) {
                const { brand, poiType } = store.properties.user_properties;

                if (total.maps.L10n.icon.brand[brand]?.icon[poiType.toLowerCase()]) {
                    imageMarker = total.maps.L10n.icon.brand[brand].icon[poiType.toLowerCase()];
                }
            }
            if (self.reverseOriginDestination) {
                roadMapElement.find(".storemap-roadmap-origin-img").attr("src", imageMarker);
                roadMapElement
                    .find(".storemap-roadmap-destination-img")
                    .attr("src", self.imageTravelMode[currentTravelMode]);
            } else {
                roadMapElement
                    .find(".storemap-roadmap-origin-img")
                    .attr("src", self.imageTravelMode[currentTravelMode]);
                roadMapElement.find(".storemap-roadmap-destination-img").attr("src", imageMarker);
            }
            const startAddress =
                currentTravelMode === "TRANSIT"
                    ? SERVICE_REGISTRY.locationService.getLocationText()
                    : directionInformations.start_address;
            const endAddress =
                currentTravelMode === "TRANSIT"
                    ? [
                          sanitizeField(store?.properties?.address?.lines?.[0]),
                          sanitizeField(store?.properties?.address?.city),
                      ]
                          .filter(Boolean)
                          .join(", ")
                    : directionInformations.end_address;
            roadMapElement.find(".storemap-roadmap-origin-text").text(startAddress);
            roadMapElement.find(".storemap-roadmap-destination-text").text(endAddress);

            const roadmapStepsTable = "";
            roadMapElement.empty();
            if (currentTravelMode === "TRANSIT") {
                directionInformations.legs.forEach((step, idx) => {
                    const row = $(templates.desktop.directionRoadmapRow.render());
                    row.find(".adp-maneuver").removeClass("adp-maneuver");
                    row.find(".storemap-roadmap-row-index").text(`${Number.parseInt(idx, 10) + 1}.`);
                    if (step.travel_mode === "pedestrian") {
                        // eslint-disable-next-line max-len
                        if (step.end_location.name) {
                            row.find(".storemap-roadmap-row-instruction").html(
                                `${total.maps.L10n.ui.transit.walk} ${total.maps.L10n.ui.transit.to} ${step.end_location.name}`,
                            );
                        } else {
                            row.find(".storemap-roadmap-row-instruction").html(
                                `${total.maps.L10n.ui.transit.walk}      `,
                            );
                        }
                    } else if (step.transport.mode) {
                        row.find(
                            ".storemap-roadmap-row-instruction",
                        ).html(`${total.maps.L10n.ui.transit.take || "Take"} ${total.maps.L10n.ui.transit.the || "the"} ${getTransitMode(step.transport.mode)} 
                ${total.maps.L10n.ui.transit.from} <b>${step.start_location.name}</b> ${total.maps.L10n.ui.transit.to} <b>${step.end_location.name}</b>`);
                    }
                    row.find(".storemap-roadmap-row-distance").text(formatDistanceValue(step.distance));
                    roadmapStepsTable.append(row);
                });
            } else {
                for (const step of steps) {
                    roadMapElement.append(
                        `<div class="wm-results--details-info-item">${step.instructions.summary}</div>`,
                    );
                }
            }

            roadMapElement
                .find(".adp-legal")
                .text(self.get("directionsRenderers")[index].directions.routes[0].copyrights);

            if (buttonElement.hasClass("storemap-active-button")) {
                roadMapElement.hide();
                buttonElement.removeClass("storemap-active-button");
            } else {
                roadMapElement.show();
                buttonElement.addClass("storemap-active-button");
            }
        };

        const onMailButtonClick = function () {
            const buttonElement = $(this);
            const containerElement = buttonElement.closest(".storemap-directionlistitem-container");
            const mailElement = containerElement.find(".storemap-directionlistitem-sendtomail");
            const moreDetailButtonElement = containerElement.find(".storemap-directionlistitem-moredetails-button");
            const moreDetailElement = containerElement.find(".storemap-directionlistitem-roadmap");

            moreDetailButtonElement.removeClass("storemap-active-button");
            moreDetailElement.hide();

            if (buttonElement.hasClass("storemap-active-button")) {
                mailElement.hide();
                buttonElement.removeClass("storemap-active-button");
            } else {
                mailElement.show();
                buttonElement.addClass("storemap-active-button");
            }
        };

        const onClearButtonClick = () => {
            self.clearOriginInput();
        };

        const onPlaceSuggestionClick = function () {
            const liElement = $(this);
            $(".wm-directions--origin-input").val(liElement[0].innerText);
            setVisibility("search-button", "hide");
        };
        const onOriginInputChanged = () => {
            const inputElement = this.mainElement.find(".wm-directions--origin-input");
            if (inputElement.val() !== "") {
                $("#directions-location").hide();
                $('[data-id="directions-switch"]').show();
            } else {
                $("#directions-location").show();
                $('[data-id="directions-switch"]').hide();
            }
        };
        const onDepartureNowButtonClick = () => {
            self.itineraryFiltersSet = true;
            resetTrafficButtons();
            const button = this.mainElement.find('button[data-id="departNow"]');
            if (button) {
                button.toggleClass("wm-active");
            }
            if (button.hasClass("wm-active")) {
                const newDate = new Date();
                onItinaryDateChange(newDate);
            } else {
                SERVICE_REGISTRY.itinaryService.setStartDatetime(null);
            }
            const originDestination = self.woosmapOriginDestinationInput.get("originDestination");

            if (originDestination) {
                self.woosmapOriginDestinationInput.set("originDestination", {
                    origin: originDestination.origin,
                    destination: originDestination.destination,
                });
            }
        };
        const resetTrafficButtons = () => {
            const selDateEl = document.getElementById("departureDt");
            const label = document.getElementById("lblDeparture");
            resetTrafficElements(label, selDateEl);
        };

        const onGeolocatlisationButtonClick = () => {
            hideGeolocationNotice();
            self.woosmapNavigatorGeolocation.askForLocation(navigator.geolocation, (error) => {
                if (error && error.code === error.PERMISSION_DENIED) {
                    showGeolocationNotice();
                }
            });
            setVisibility("search-button", "hide");
            // total.maps.utils.EventManager.notify(EVENT.GEOLOCATION_CLICKED, null);
            // self.mainElement.find(".storemap-inputbar-input").val("");
        };

        const onTravelModeSpanClick = function () {
            const selectedSpan = $(this);
            self.mainElement
                .find(".woosmap-travel-mode-option")
                .removeClass("selected")
                .removeClass("storemap-mode-selected");
            selectedSpan.addClass("storemap-mode-selected").addClass("selected");
            self.woosmapDirectionsProvider.set("selectedTravelMode", selectedSpan.attr("data-travel-mode"));
        };

        const onReverseDirectionClick = () => {
            const storeOriginContainer = self.mainElement.find("#storemap-directionsearchbar-store-origin-container");
            const storeDestinationContainer = self.mainElement.find(
                "#storemap-directionsearchbar-store-destination-container",
            );
            const inputSearchLabel = self.mainElement.find(
                "#storemap-directionsearchbar-searchinput-container .storemap-inputbar-label",
            );
            const firstReverseButton = self.mainElement.find(
                ".storemap-directionsearchbar-reverse-button.first-reverse-button",
            );
            const secondReverseButton = self.mainElement.find(
                ".storemap-directionsearchbar-reverse-button.second-reverse-button",
            );

            if (storeOriginContainer.is(":visible")) {
                storeOriginContainer.hide();
                storeDestinationContainer.show();
                firstReverseButton.hide();
                secondReverseButton.show();
                self.reverseOriginDestination = false;
                inputSearchLabel.text(total.maps.L10n.ui.directions.departure);
            } else {
                storeOriginContainer.show();
                storeDestinationContainer.hide();
                firstReverseButton.show();
                secondReverseButton.hide();
                self.reverseOriginDestination = true;
                inputSearchLabel.text(total.maps.L10n.ui.directions.arrival);
            }

            const originDestination = self.woosmapOriginDestinationInput.get("originDestination");

            if (originDestination) {
                self.woosmapOriginDestinationInput.set("originDestination", {
                    origin: originDestination.destination,
                    destination: originDestination.origin,
                });
            }

            self.mainElement.find(".storemap-directionlistitem-container").each(function () {
                const container = $(this);
                container.find(".storemap-active-button").removeClass("storemap-active-button");
                container.find(".storemap-directionlistitem-roadmap").hide();
                container.find(".storemap-directionlistitem-sendtomail").hide();
            });
        };

        function onSuggestionClick(event) {
            const suggestion = $(this);
            self.mainElement.find(".storemap-inputbar-input").val(suggestion.text());
            event.stopPropagation();
        }

        function onInputSearchEnterKeydown(event) {
            if (event.which === 13 || event.keyCode === 13) {
                self._selectFirstResultOfSuggestion();
            }
        }

        function onSearchButtonClick() {
            self._selectFirstResultOfSuggestion();
        }
        function onGoogleMapsButtonClick() {
            const store = SERVICE_REGISTRY.storeService.getSelectedStore();
            if (store) {
                const directionUrl = generateGoogleMapsDirectionUrl(store.geometry.coordinates);
                window.open(directionUrl, "_blank");
            }
        }
        function onWazeMapsButtonClick() {
            const store = SERVICE_REGISTRY.storeService.getSelectedStore();
            if (store) {
                const directionUrl = generateWazeDirectionUrl(store.geometry.coordinates);
                window.open(directionUrl, "_blank");
            }
        }

        this.mainElement.find('[data-id="cancel-button"]').click(onCloseButtonClick);
        this.mainElement.on("click", ".wm-directions--result", onContainerClick);
        this.mainElement.on("click", ".wm-directions--result-actions span", onMoreDetailsButtonClick);
        this.mainElement.on("click", ".storemap-directionlistitem-mail-button", onMailButtonClick);
        this.mainElement.find(".storemap-inputbar-clear-button").click(onClearButtonClick);
        this.mainElement.on("click", ".storemap-suggestionbar-container ul li", onPlaceSuggestionClick);
        this.mainElement.on("click", "#directions-location", onGeolocatlisationButtonClick);
        this.mainElement.find(".woosmap-travel-mode-option").click(onTravelModeSpanClick);
        this.mainElement.find(".storemap-directionsearchbar-reverse-button span").click(onReverseDirectionClick);
        this.mainElement.find("[data-id='directions-switch']").click(onReverseDirectionClick);
        this.mainElement.on("click", ".storemap-suggestion-item", onSuggestionClick);
        this.mainElement.on("keydown", ".storemap-inputbar-input", onInputSearchEnterKeydown);
        this.mainElement.on("click", ".storemap-inputbar-enter-button", onSearchButtonClick);
        this.mainElement.find(".wm-directions--origin-input").change(onOriginInputChanged);
        this.mainElement.find('[data-id="departNow"]').click(onDepartureNowButtonClick);
        this.mainElement.find("#google-maps").click(onGoogleMapsButtonClick);
        this.mainElement.find("#waze-maps").click(onWazeMapsButtonClick);
        // Handle browser resize
        window.addEventListener("resize", () => {
            if (window.innerWidth < 768) {
                this.setupDirectionsDetails();
            } else {
                setVisibility("directions-details-button", "hide");
                setVisibility("directions-results", "show");
            }
        });
    }
    setStore() {
        const store = SERVICE_REGISTRY.storeService.getSelectedStore();

        const brandIcon = this.mainElement.find(".wm-directions--img")[0];
        brandIcon.setAttribute("alt", store.properties.name);
        addBrandIconForDetailView(brandIcon, store);

        const type = store.properties.user_properties.poiType;
        const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
        this.mainElement.find(".wm-directions--title")[0].textContent = store.properties.name;
        this.mainElement.find(".wm-directions--type")[0].textContent = poiTypeToDisplay;
        this.mainElement.find(".wm-directions--address")[0].textContent = concatenateStoreAddress(store);

        return `${store.geometry.coordinates[0]},${store.geometry.coordinates[1]}`;
    }
    location_changed() {
        const location = this.get("location");
        this.userLocation = location;

        let originLocation = null;
        let destinationLocation = null;

        if (location && (typeof location.source !== "undefined" || !("source" in location))) {
            const inputElement = this.mainElement.find(".wm-directions--origin-input");

            if (!$.isEmptyObject(this.get("location"))) {
                if (inputElement.val() === "") {
                    inputElement.val(total.maps.L10n.ui.common.myLocation).trigger("change");
                    this.mainElement.find(".storemap-inputbar-clear-button").show();
                }

                originLocation = `${this.get("location").lng},${this.get("location").lat}`;

                const selectedStore = SERVICE_REGISTRY.storeService.getSelectedStore();

                if (selectedStore?.properties)
                    destinationLocation = `${selectedStore.geometry.coordinates[0]},${selectedStore.geometry.coordinates[1]}`;

                this.mainElement.find(".wm-directions--external-actions").addClass("wm-hidden");

                if (originLocation && destinationLocation) {
                    this.woosmapOriginDestinationInput.set("originDestination", {
                        origin: originLocation,
                        destination: destinationLocation,
                    });
                }
            } else {
                inputElement.val("");
                this.mainElement.find(".storemap-inputbar-clear-button").hide();
            }
        }
    }

    directionsSummaries_changed() {
        const directionsSummaries = this.get("directionsSummaries");
        const directionListBar = this.mainElement.find(".wm-directions--results-list");
        const detailsButton = document.querySelector('[data-id="directions-details-button"]');
        if (detailsButton && !this.itineraryFiltersSet) {
            const expandLabel = detailsButton.querySelector(".wm-btn--label-expand");
            const reduceLabel = detailsButton.querySelector(".wm-btn--label-reduce");
            if (expandLabel) expandLabel.classList.remove("wm-hidden");
            if (reduceLabel) reduceLabel.classList.add("wm-hidden");
            // toggleDirectionsDetails();
        }
        directionListBar.empty();
        if (directionsSummaries) {
            const travelModeIcon = {
                WALKING: "walk",
                BICYCLING: "bike",
                DRIVING: "car",
                TRANSIT: "bus",
            };

            directionsSummaries.forEach((summary, idx) => {
                const item = $(
                    $.parseHTML(
                        templates.desktop.directionItem.render({
                            ui: total.maps.L10n.ui,
                            index: idx,
                            summary: summary.summary || "",
                            originalIndex: idx,
                        }),
                    ),
                );

                item.find(".wm-directions--result-eta i")[0].setAttribute(
                    "data-icon",
                    travelModeIcon[summary.travelMode.toUpperCase()],
                );

                // convert to meters
                const distance = Number.parseFloat(summary.distance.split(" ")[0]) * 1000;

                item.find(".wm-directions--result-eta-info")[0].innerText =
                    `${formatDistanceValue(distance)} - ${summary.durationShort}`;

                if (summary.summary !== "") {
                    item.find(".wm-directions--result-title")[0].innerText =
                        `${total.maps.L10n.ui.directions.via} ${summary.summary}`;
                } else {
                    item.find(".wm-directions--result-title")[0].innerText =
                        `${total.maps.L10n.ui.directions.route} ${Number.parseInt(idx, 10) + 1}`;
                }
                const departureTimeEnabled = this.mainElement.find('button[data-id="departNow"]');
                if (departureTimeEnabled?.hasClass("wm-active")) {
                    item.find(".wm-directions--result-actions").addClass("wm-hidden");
                }
                const departureDateSet = this.mainElement.find('button[data-id="calendar"]');
                if (departureDateSet?.hasClass("wm-active")) {
                    item.find(".wm-directions--result-actions").addClass("wm-hidden");
                }
                directionListBar.append(item);
            });
            initIcons();
            this.selectDirectionInList(0);

            this.mainElement.find("#storemap-directionlistbar-message-container").hide();
            directionListBar.show();
            setVisibility("search-button", "hide");
            if (window.innerWidth < 768) {
                const destinationBlock = this.mainElement.find("directions-destination");
                if (destinationBlock && !destinationBlock.hasClass("wm-hidden")) {
                    destinationBlock.addClass("wm-hidden");
                }
                if (!this.itineraryFiltersSet) {
                    setVisibility("directions-results", "hide");
                    this.setupDirectionsDetails();
                }
            } else {
                setVisibility("directions-details-button", "hide");
                setVisibility("directions-results", "show");
            }
        } else {
            this.mainElement.find("#storemap-directionlistbar-message-container").show();
            directionListBar.hide();
            setVisibility("directions-results", "hide");
            setVisibility("search-button", "show");
            this._clearMap();
        }
    }
    isDirectionResultsExpanded() {
        const resultsBlock = document.querySelector('[data-id="directions-results"]');
        if (resultsBlock) {
            const isVisible = !resultsBlock.classList.contains("wm-hidden");
            return isVisible;
        }
    }

    selectDirectionInList(index) {
        const directionListContainer = this.mainElement.find(".wm-directions--result");
        directionListContainer.removeClass("storemap-selected-item");
        $(directionListContainer.get(index)).addClass("storemap-selected-item");
    }

    _getCurrentTravelMode() {
        return this.mainElement.find(".woosmap-travel-mode-option.selected").attr("data-travel-mode");
    }

    predictions_changed() {
        const predictions = this.get("predictions");
        if (predictions) {
            if (predictions.length === 0) {
                this.mainElement.find(".storemap-suggestionbar-container").hide();
            } else {
                this.mainElement.find(".storemap-suggestionbar-container").show();
            }
        } else {
            this.mainElement.find(".storemap-suggestionbar-container").hide();
        }
    }
    onSelectedStoreChange() {
        if (this.blockSelectedStoreEvent) return;

        const storeLocation = this.setStore();
        const { userLocation } = this;

        if (!$.isEmptyObject(userLocation) && userLocation.lat) {
            const userStringLocation = `${userLocation.lng},${userLocation.lat}`;

            if (this.reverseOriginDestination) {
                this.woosmapOriginDestinationInput.set("originDestination", {
                    origin: storeLocation,
                    destination: userStringLocation,
                });
            } else {
                this.woosmapOriginDestinationInput.set("originDestination", {
                    origin: userStringLocation,
                    destination: storeLocation,
                });
            }
        }
    }

    _clearMap() {
        this.markers.clear();
        // this.woosmapDirectionsResultsDisplayer.cleanMapFromRoutes();
        cleanMapFromRoutes(this.woosmapDirectionsProvider);

        const directionListBar = this.mainElement.find("#storemap-directionlistbar-container");
        directionListBar.empty();
        this.woosmapOriginDestinationInput.set("selectedStore", null);
        this.woosmapOriginDestinationInput.setDestinationValue("");
        // this.mainElement.find("#storemap-directionlistbar-message-container").hide();
    }
    _resetScheduleButtons() {
        const resultsContainer = document.querySelector(".wm-directions--results");
        const scheduleButtons = resultsContainer.querySelectorAll(".wm-results--schedule .wm-btn--pill");
        for (const btn of scheduleButtons) {
            btn.classList.remove("wm-active");
        }
    }

    get markers() {
        const self = this;

        function make(map, position, icon, title) {
            self.directionsMarkers.push(
                new google.maps.Marker({
                    position,
                    map,
                    icon,
                    title,
                }),
            );
        }

        function clear() {
            for (const marker of self.directionsMarkers) {
                marker.setMap(null);
            }
            self.directionsMarkers = [];
        }

        return {
            make,
            clear,
        };
    }

    _selectFirstResultOfSuggestion() {
        const woosmapSuggestionContainer = this.mainElement.find(".woosmap-tableview-container.card_container");
        const woosmapSuggestionItems = woosmapSuggestionContainer.find(".storemap-suggestion-item");

        if (woosmapSuggestionContainer.is(":visible") && woosmapSuggestionItems) {
            $(woosmapSuggestionItems[0]).trigger("click");
        }
    }
}
